import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export default function Footer() {
  const { lang } = useLang();
  return (
    <footer className="border-t border-white/10 px-6 sm:px-10 lg:px-14 py-14 bg-black" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 items-end">
        <div>
          <div className="font-serif text-3xl text-white leading-tight">Davide Perugini</div>
          <div className="text-lg text-neutral-300 mt-1">Supercar &amp; Classic Cars</div>
          <div className="label-eyebrow mt-3 text-neutral-500">Davide Perugini · Italia</div>
        </div>
        <div className="text-neutral-500 text-sm leading-relaxed max-w-md">
          {lang === "en"
            ? "Selection, sourcing and sale of supercars and classic cars. Personal consultancy across Italy, Europe and the rest of the world."
            : "Selezione, ricerca e vendita di supercar e auto classiche. Consulenza personale su tutta Italia, Europa e resto del mondo."}
        </div>
        <div className="flex md:justify-end gap-6 label-eyebrow text-neutral-500">
          <a href="https://instagram.com/davideperugini.cars" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram">Instagram</a>
          <Link to="/vetture" data-testid="footer-vetture">{lang === "en" ? "Cars" : "Vetture"}</Link>
          <a href="#chi-sono" data-testid="footer-about">{lang === "en" ? "About" : "Chi sono"}</a>
          <a href="#contatti" data-testid="footer-contatti">{lang === "en" ? "Contact" : "Contatti"}</a>
          <Link to="/login" data-testid="footer-admin">Admin</Link>
        </div>
      </div>
      <div className="max-w-[1600px] mx-auto mt-10 pt-6 border-t border-white/5 text-xs text-neutral-500 leading-relaxed" data-testid="footer-legal">
        <p>
          {lang === "en"
            ? "Copyright 2026 © Davide Perugini Cars. All rights reserved. Unauthorised reproduction of the images and contents of this website is forbidden. Customers' personal data is processed in compliance with the applicable privacy regulations."
            : "Copyright 2026 © Davide Perugini Cars. Tutti i diritti riservati. È vietata la riproduzione non autorizzata delle immagini e dei contenuti del sito. I dati personali dei clienti sono trattati nel rispetto delle normative vigenti sulla privacy."}
        </p>
        <p className="mt-3 text-neutral-700">P.IVA · Made with care</p>
      </div>
    </footer>
  );
}
